import { NgModule } from '@angular/core';
import { Router, RouterModule, Routes } from '@angular/router';
import { authGuard } from '@authentication/auth.guard';
import { Shell } from '@shell/shell.service';
import { ControlCreditoIndexComponent } from './control-credito-index/control-credito-index.component';
import { ReporteSaldosComponent } from './reportes/reporte-saldos/reporte-saldos.component';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { AuthService } from '@authentication/auth.service';
import { NivelesAprobacionComponent } from './niveles-aprobacion/niveles-aprobacion.component';
import { TipoReporte } from '@shared/enums/tipoReporte';
import { ReporteDeBloqueosComponent } from './reportes/reporte-de-bloqueos/reporte-de-bloqueos.component';
import { ReporteAutorizacionesComponent } from "@controlCredito/reportes/reporte-autorizaciones/reporte-autorizaciones.component";

const routes: Routes = [
  Shell.childRoutes([
    { path: 'controlCredito', redirectTo: 'controlCredito/saldos', pathMatch: 'full' },
    {
      path: "controlCredito",
      component: ControlCreditoIndexComponent,
      canActivate: [authGuard],
      data : { roles: [TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV, TipoUsuario.CONTROLCREDITO, TipoUsuario.APROBADORBYR, TipoUsuario.SEGURIDADTABLAS, TipoUsuario.EJECUTIVOCUENTA, TipoUsuario.SOPORTE] }, //TipoUsuario.JEFEDEAEROPLANTA, TipoUsuario.TUTOR, TipoUsuario.CONTROLCREDITO
      children: [
        {
          path: 'saldos',
          component: ReporteSaldosComponent,
          canActivate: [authGuard],
          data : { roles: [TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV, TipoUsuario.CONTROLCREDITO, TipoUsuario.APROBADORBYR, TipoUsuario.EJECUTIVOCUENTA, TipoUsuario.SOPORTE] }
        },
        {
          path: 'nivelesAprobacion',
          component: NivelesAprobacionComponent,
          canActivate: [authGuard],
          data: { roles: [TipoUsuario.SEGURIDADTABLAS] }
        },
        {
          path: 'bloqueosAutomaticos',
          component: ReporteDeBloqueosComponent,
          canActivate: [authGuard],
          data: { roles: [TipoUsuario.COMERCIAL, TipoUsuario.EJECUTIVOCUENTA, TipoUsuario.COMERCIAL_AV, TipoUsuario.COMERCIAL_LN, TipoUsuario.CONTROLCREDITO, TipoUsuario.APROBADORBYR] },
        },
        {
          path: 'reporteAutorizaciones',
          component: ReporteAutorizacionesComponent,
          canActivate: [authGuard],
          data: { roles: [TipoUsuario.COMERCIAL, TipoUsuario.COMERCIAL_LN, TipoUsuario.COMERCIAL_AV, TipoUsuario.CONTROLCREDITO, TipoUsuario.APROBADORBYR, TipoUsuario.EJECUTIVOCUENTA] },
        }
      ]
    }
  ])
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ControlCreditoRoutingModule {
  constructor(private authService: AuthService, private router: Router) {
    this.router.events.subscribe((event) => {
      if (event['url'] && event['url'] == '/controlCredito') {
        this.redireccionar();
      }
    });
  }

  redireccionar() {
    if(this.authService.hasRole(TipoUsuario.SEGURIDADTABLAS)) {
      this.router.navigate(['/controlCredito/nivelesAprobacion']);
    } else {
      this.router.navigate(['/controlCredito/saldos/'], {queryParams:{solapaReporte:TipoReporte.reporteSaldo}});
    }
  }
}
